import { FC } from 'react'
import { CardTable, Toolbar } from 'shared'
import { useNavigate } from 'react-router'
import '../../../scss/common/list/List.scss'
import { SMSIcon, AgroBeetApp } from 'assets/images'
import { notifyWarning } from 'utils'
import WhatsAppIcon from '../../../assets/images/WhatsApp.jpg'
import useAuth from '../../../hooks/Auth'

const ChannelType: FC = () => {
  const Navigate = useNavigate()
  const { setopenEditProfile, isSubsId, isCompanyVerified } = useAuth()
  const channelData = [
    {
      id: 1,
      globalName: 'WhatsApp',
      imageUrl: WhatsAppIcon
    },
    {
      id: 2,
      globalName: 'SMS',
      imageUrl: SMSIcon
    },
    {
      id: 3,
      globalName: 'AgroBeet-App',
      imageUrl: AgroBeetApp
    }
  ]
  const total = channelData?.length ?? 0

  const options = [{ label: 'Channel Type', value: '', onClick: () => {} }]
  const handleCardSelection = (rowData: any) => {
    if (!isSubsId) {
      setopenEditProfile(true)
    } else if (!isCompanyVerified) {
      notifyWarning(
        'Sorry, your company documents are not verified yet. Once they verified, our team will contact you soon.'
      )
    } else {
      Navigate(`/channels/${rowData.globalName}`, {
        state: { selectedChannel: rowData.globalName }
      })
    }
  }
  return (
    <div className="list">
      <Toolbar options={options} total={total} />
      <div className="list__main-container">
        <CardTable
          handleSelection={handleCardSelection}
          data={channelData ?? []}
          loading={false}
          handleCardClick={() => {}}
          farmTypeCard
        />
      </div>
    </div>
  )
}
export default ChannelType
